if (!customElements.get('tru-product-safety')) {
  customElements.define('tru-product-safety', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.tru-product-safety__link');
      opener.addEventListener('click', () => dialog.showModal());
      this.querySelector('.tru-product-safety__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener.focus());
    }
  });
}
